import { useState } from "react";
import { Outlet, useLocation,useRouteLoaderData, useSearchParams, Link, useSubmit } from "react-router-dom";
import UserInfo from "src/components/common/userInfo";
import { useAuthStore, User } from "src/components/main/authStore";
import {
    simpleStatusColorCode,
} from "src/components/common/functions";
import { Billing } from "./types";
import ServerFooter from "../common/ServerFooter";
export const extraFields = ["page", "limit", "createdAtFrom", "createdAtTo"];

export default function Billings() {

    const [searchParams, setSearchParams] = useSearchParams();
    const submit = useSubmit();
    const user = useAuthStore(state => state.user) as User;
    const { billings, start: defaultStartDate, end: defaultEndDate, total }:{ billings: Billing[], start: string, end: string, total: number } = useRouteLoaderData("Billings")!; 
    const [fromDate, setStartDate] = useState(defaultStartDate);
    const [toDate, setEndDate] = useState(defaultEndDate);
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;
    const updateBilled = (billing: Billing) => {
        const isBilled = billing.billed === "yes";
        if (!window.confirm(`Are you sure to set this as ${isBilled ? "unbilled" : "billed"}?`)) return;
        const formData = new FormData();
        formData.append("id", billing.id);
        formData.append("billed", isBilled ? "no" : "yes");
        submit(formData, {
            method: "post",
            action: `Billed${location.search}`,
        });
    };
    return (
        <div className="cssContent pb8rem">
            <nav className="my-3">
                <span children = "Submission Date Range" className = "me-2 fw-bold"/>
                <label children = "Start" htmlFor = "fromDate" className = "text-nowrap me-2 mb-0"/>
                <input
                    type = "date" 
                    id = "fromDate" 
                    name = "fromDate" 
                    className = "form-control inline me-3" 
                    value = {fromDate} 
                    max = {toDate}
                    onChange = {e => setStartDate(e.currentTarget.value)}
                />
                <label children = "End" htmlFor = "toDate" className = "text-nowrap me-2 mb-0"/>
                <input 
                    type = "date" 
                    id = "toDate" 
                    name = "toDate" 
                    className = "form-control inline me-3" 
                    value = {toDate} 
                    min = {fromDate}
                    onChange = {e => setEndDate(e.currentTarget.value)}
                />
                <button
                    children = "Load"
                    disabled = {defaultStartDate === fromDate && defaultEndDate === toDate}
                    type = "button"
                    value = "load"
                    id = "load"
                    className = "form-control inline me-3" 
                    onClick = {e => {
                        const params = new URLSearchParams(searchParams);
                        params.set("createdAtFrom", fromDate);
                        params.set("createdAtTo", toDate);
                        setSearchParams(params, { replace: false });  
                    }}
                />
                <Link className = {"btn btn-outline-primary pointer ms-3 position-relative"} to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                   {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.2em"}}/>:null}
                </Link>
                <Link children = "Export" className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}/>
                <Link children = "Add" className = "btn btn-outline-primary pointer ms-3" to = "Add"/>
            </nav>
            <div>
                {!billings.length ? (
                    <div className="cssLoading">Empty</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr className="noBorderTop">
                                    <th>Billing Number</th>
                                    <th>Project</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Amount ($)</th>
                                    <th>Submitter</th>
                                    <th>Submit Time</th>
                                    <th>PDF</th>
                                    <th>Status</th>
                                    <th>Billed</th>
                                    {user.projects !== "no"?<th></th>:null}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {billings.map((billing, key) => (
                                    <tr key = {key} style={{ color: (simpleStatusColorCode as Record<string, string>)[billing.decision ?? "Submitted"] }}>
                                        <td>
                                            {billing.billingNumber}
                                        </td>
                                        <td>
                                            <Link to={`/Projects/${billing.projectId}`}>{billing.projectName}</Link>
                                        </td>
                                        <td>{billing.fromDate}</td>
                                        <td>{billing.toDate}</td>
                                        <td>{billing.amount}</td>
                                        <td>{billing.submitterId? <UserInfo name={billing.submitterName!} id={billing.submitterId} /> : null}</td>
                                        <td>{billing.submitTime}</td>
                                        <td>
                                            {billing.pdfId ? (
                                                <a
                                                    className="btn btn-primary"
                                                    href={`https://drive.google.com/file/d/${billing.pdfId}/view?usp=drivesdk`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    View
                                                </a>
                                            ) : null}
                                        </td>
                                        <td>{billing.status}</td>
                                        <td>{billing.billed}</td>
                                        {user.projects !== "no"?<td><button children = {billing.billed === "yes"? "Unset send" : "Set send"} className="btn btn-primary" onClick={() => updateBilled(billing)}/></td>:null}
                                        <td>
                                            <Link children = "Detail" to = {String(billing.id)} className="btn btn-outline-primary"/>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                {total?
                <ServerFooter
                    length = {total}
                />
                :null}
            </div>
            <Outlet/>
        </div>
    );
}
